import { module } from 'modujs';
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.mask = this.el.querySelector('.o-intro_mask');
        this.maskLogo = this.mask.querySelector('.c-logo');
        
        this.animation = this.el.querySelector('.o-intro_animation');
        this.logo = this.animation.querySelector('.c-logo');
        this.line1 = this.logo.querySelector('.c-logo_line1');
        this.line2 = this.logo.querySelector('.c-logo_line2');
        this.line3 = this.logo.querySelector('.c-logo_line3');
    }

    init() {
        let tl = gsap.timeline({
            onComplete: () => { this.endIntro(); }
            // repeat: -1, repeatDelay: 0.5
        });
        
        let tlPulse = gsap.timeline({ repeat: 1 });
        tlPulse.fromTo(
            this.logo,
            { scale: 1, rotate: 0 },
            { scale: 1.1, rotate: 2, duration: 0.2, ease: 'power1' }
        )
        tlPulse.fromTo(
            this.logo,
            { scale: 1.1, rotate: 2 },
            { scale: 1, rotate: 0, duration: 0.2, ease: 'power1' }
        )
        tl.add(tlPulse);

        tl.addLabel('letters', '+=0.2');

        tl.fromTo(
            this.line1.querySelectorAll('.c-logo_letter'),
            { y: '105%', scaleX: 0.1, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, scaleY: 1, ease: 'elastic.out(1,0.45)', duration: 1.2, stagger: { amount: 0.25, from: 'random' } },
            'letters'
        );
        tl.fromTo(
            this.line2.querySelectorAll('.c-logo_letter'),
            { y: '105%', scaleX: 0.1, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, scaleY: 1, ease: 'elastic.out(1,0.45)', duration: 1.2, delay: 0.3, stagger: { amount: 0.25, from: 'random' } },
            'letters'
        );
        tl.fromTo(
            this.line3.querySelectorAll('.c-logo_letter'),
            { y: '105%', scaleX: 0.1, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, scaleY: 1, ease: 'elastic.out(1,0.45)', duration: 1.2, delay: 0.6, stagger: { amount: 0.25, from: 'random' } },
            'letters'
        );
        tl.fromTo(
            this.line3.querySelectorAll('.c-logo_dot'),
            { y: 50, scaleX: 0, transformOrigin: 'top center' },
            { y: 0, scaleX: 1, ease: 'elastic.out(1,0.45)', duration: 1.2 },
            "-=1"
        );

        tl.addLabel('hide', '+=1');

        tl.to(
            this.el.querySelectorAll('.c-logo_letter'),
            { y: '105%', ease: 'power4.out', duration: 0.4, stagger: { amount: 0.2, from: 'random' } },
            'hide'
        );
        tl.to(
            this.el.querySelectorAll('.c-logo_dot'),
            { y: 50, ease: 'power4.out', duration: 0.4 },
            'hide'
        );

        tl.addLabel('zoomIn', '-=0.3');

        tl.set(this.el, { pointerEvents: 'none' }, 'zoomIn');
        tl.call(() => {
            this.call('start', 'Scroll');
            this.call('play', null, 'Video', 'hero');
            setTimeout(() => {
                this.call('start', 'Stopwatch');
            }, 750);
        });
        
        tl.to(
            this.animation,
            { opacity: 0, duration: 0.25, ease: 'none' },
            'zoomIn'
        )
        tl.to(
            this.maskLogo,
            { scale: 7, rotate: 13, duration: 0.6, delay: 0.3, ease: 'back.in(1.2)' },
            'zoomIn'
        );
    }

    endIntro() {
        this.el.classList.add('-hidden');
        this.call('play', 'Header');
    }

}
